import React, { Component } from 'react';
import Comment from '../../../../../common/comments/comment.component';
import { Loading } from '../../../../../common/loading';
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';

class RechargingEquipmentComments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }

    }

    componentDidMount() {
        const { getRechargeComments, rechargeInventoryId, rechargeInventoryDetails } = this.props;
        const { rechargeComments, pageIndex } = this.props.rechargeInventoryDetails;
        getRechargeComments(rechargeInventoryId, pageIndex, 5, false )
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment = async (attachedFilename, attachedFileData, commentDescription) => {
        const { postRechargeComments, getRechargeComments, rechargeInventoryId } = this.props;
        await postRechargeComments(rechargeInventoryId, attachedFilename, attachedFileData, commentDescription);
        // await getRechargeComments(rechargeInventoryId)
        //     .then(() => {
        //         this.setState({ isLoading: false })
        //     });
    }

    handleDeleteOrderDetailsComments = async (commentID) => {
        this.setState({ isLoading: true });
        const { deleteRechargeComments, getRechargeComments, rechargeInventoryId, resetRechargeComments } = this.props;
        const { rechargeComments } = this.props.rechargeInventoryDetails;

        await deleteRechargeComments(commentID, rechargeInventoryId);
        resetRechargeComments();
        await getRechargeComments(rechargeInventoryId, 1, rechargeComments.length ).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

     handleLoadMore = async () =>{
        const {getRechargeComments, rechargeInventoryId, rechargeInventoryDetails } = this.props;
        const { pageCommentsIndex } = rechargeInventoryDetails;
        await getRechargeComments(rechargeInventoryId, pageCommentsIndex + 1);
    }

    componentWillUnmount() {
        const { resetRechargeComments } = this.props;

        resetRechargeComments();
        
    }

    render() {
        const { isReadOnly, isReadAndExtractOnly, isReadAndWrite} = this.props;
        const { rechargeComments, hasMoreRechargeComments } = this.props.rechargeInventoryDetails;
        if (this.state.isLoading) {
            return <Loading />
        }
        return (
            <>
                <Comment
                    commentList={rechargeComments}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteOrderDetailsComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isRechargeInventoryComment={true}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={hasMoreRechargeComments}
                    //Access Types
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly }
                    isReadAndWrite={isReadAndWrite}
                />
            </>
        );
    }
}


export default connect(
    state => {
        const { rechargeInventoryComments, rechargeInventoryDetails, rechargeComments } = state;
        
        return {
            rechargeInventoryComments, rechargeInventoryDetails, rechargeComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, RechargeInventoryDetailsActions),
        dispatch
    )
)(RechargingEquipmentComments);